import http from '@/utils/http';
import i18n from '@/main';

export default {
    findEstados(lockScreen = true) {
        return http.get({
            url: `/estados`,
            lockMessage: i18n.t('mensagens.sistema.aguardeBuscandoEstados'),
            lockScreen
        });
    },

    findMunicipios(estado, lockScreen = true) {
        return http.get({
            url: `/estados/${estado}/municipios`,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosDeMunicipio'),
            lockScreen
        });
    },

    buscarLocalidadeNivelUm(lockScreen = true) {
        return http.get({
            url: `/localidade/nivel1`,
            lockMessage: i18n.t('mensagens.sistema.aguardeBuscandoEstados'),
            lockScreen
        });
    },

    buscarLocalidadeNivelTres(id, lockScreen = true) {
        return http.get({
            url: `/localidade/nivel3/${id}`,
            lockMessage: i18n.t('mensagens.sistema.aguardeBuscandoLocalidad'),
            lockScreen
        });
    },

    buscarLocalidadeNivelDois(idNivelSuperior, lockScreen = true) {
        return http.get({
            url: `/localidade/nivel2/${idNivelSuperior}`,
            lockMessage: i18n.t('mensagens.sistema.aguardeBuscandoEstados'),
            lockScreen: false
        });
    },
    validarRaioLocalidade(data, lockScreen = false) {
        return http.post({
            url: '/localidade/localidade-raio/validar',
            data: data,
            lockScreen,
            lockMessage: i18n.t('mensagens.sistema.buscandoInformacoes')
        });
    },
    validarRaioLocalidadeAr(data, lockScreen = false) {
        return http.post({
            url: '/localidade/localidade-raio/validar-ar',
            data: data,
            lockScreen,
            lockMessage: i18n.t('mensagens.sistema.buscandoInformacoes')
        });
    },
    buscarLocalidadesPorGeometria(geometria, lockScreen = false) {
        return http.post({
            url: '/localidade/buscar-por-geometry',
            data: geometria,
            lockScreen,
            lockMessage: i18n.t('mensagens.sistema.buscandoInformacoes')
        });
    }
};
